import ResourceService from "./resource.service";
import Vue from "vue"
class JVService extends ResourceService {
  static get resource() {
    return "journal-voucher";
  }

  static cancelJV (id) {
    const url = `${this.resource}/cancel/${id}`;
    return new Promise((resolve, reject) => {
      Vue.axios
        .put(url)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default JVService;
